import { callApi, getHotelId, getItem } from 'utils/globalFunction';
import config from 'config/index';
import { API_ROUTES, LOCALSTORAGE_KEYS } from 'utils/globalVariable';

export const getAllSchedules = async ({
  advanceFilters,
  searchText,
  offset = 0,
  limit = 100,
  ...props
}: {
  advanceFilters?: any;
  searchText?: string;
  offset?: number;
  limit?: number;
  [x: string]: any;
}) => {
  try {
    const wsId = getHotelId() as string;
    const response = await callApi(
      config.REACT_APP_BASE_URL + `task/workspaces/${wsId}/all-schedules`,
      {
        ...(advanceFilters && { advanceFilters }),
        ...(searchText && { searchText }),
        offset,
        limit,
        ...props,
      },
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return response?.data?.data;
  } catch (res) {
    return res;
  }
};

export const getOverdueSchedules = async ({
  scheduleType,
  advanceFilters,
  searchText,
  offset = 0,
  limit = 100,
  ...props
}: {
  advanceFilters?: any;
  searchText?: string;
  offset?: number;
  limit?: number;
  [x: string]: any;
}) => {
  try {
    const wsId = getHotelId() as string;
    const response = await callApi(
      config.REACT_APP_BASE_URL + `task/workspaces/${wsId}/overdue-schedules`,
      {
        ...(advanceFilters && { advanceFilters }),
        ...(searchText && { searchText }),
        offset,
        limit,
        ...props,
      },
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return response?.data?.data;
  } catch (res) {
    return res;
  }
};

export const getCompletedSchedules = async ({
  advanceFilters,
  searchText,
  offset = 0,
  limit = 100,
  ...props
}: {
  advanceFilters?: any;
  searchText?: string;
  offset?: number;
  limit?: number;
  [x: string]: any;
}) => {
  try {
    const wsId = getHotelId() as string;
    const response = await callApi(
      config.REACT_APP_BASE_URL + `task/workspaces/${wsId}/completed-schedules`,
      {
        ...(advanceFilters && { advanceFilters }),
        ...(searchText && { searchText }),
        offset,
        limit,
        ...props,
      },
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return response?.data?.data;
  } catch (res) {
    return res;
  }
};

export const getParentSchedules = async ({
  advanceFilters,
  searchText,
  offset = 0,
  limit = 100,
  ...rest
}: {
  advanceFilters?: any;
  searchText?: string;
  offset?: number;
  limit?: number;
}) => {
  try {
    const wsId = getHotelId() as string;
    const response = await callApi(
      config.REACT_APP_BASE_URL +
        `task/workspaces/${wsId}/parent-schedules/list`,
      {
        advanceFilters: null,
        ...(advanceFilters && { advanceFilters }),
        ...(searchText && { searchText }),
        offset,
        limit,
        ...rest,
      },
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return response?.data?.data;
  } catch (res) {
    return res;
  }
};

export const getScheduleTaskHistory = async (taskId: string) => {
  try {
    const wsId = getHotelId() as string;
    const response = await callApi(
      config.REACT_APP_BASE_URL +
        `task/workspaces/${wsId}/scheduled-tasks/${taskId}/history`,
      {},
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return response?.data?.data;
  } catch (res) {
    return res;
  }
};
